<template>
  <div class="mt-1 mb-10">
    <!-- TO BE DONE -->
    <!-- <v-container class="grey lighten-3">
      <h1>Hello test</h1>
    </v-container>-->

    <v-container fluid>
      <v-row dense class="ma-n4 pb-5">
        <!-- <v-col cols="12" sm="6" lg="4" xl="3"> -->
        <v-col cols="12">
          <SectionInfo></SectionInfo>
          <SectionClient></SectionClient>
          <SectionWorkItems></SectionWorkItems>
          <SectionInvoices></SectionInvoices>
          <SectionExpenses></SectionExpenses>
          <SectionTimesheets></SectionTimesheets>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SectionInfo from "./sections/SectionInfo";
import SectionClient from "./sections/SectionClient";
import SectionWorkItems from "./sections/SectionWorkItems";
import SectionInvoices from "./sections/SectionInvoices";
import SectionExpenses from "./sections/SectionExpenses";
import SectionTimesheets from "./sections/SectionTimesheets";

export default {
  name: "ProjectItemMobile",
  components: {
    SectionInfo,
    SectionClient,
    SectionWorkItems,
    SectionInvoices,
    SectionExpenses,
    SectionTimesheets
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style scoped>
.card-listitem {
  background-color: #e4ecfb;
}
</style>

<style>
.chip-type {
  display: inline-block;
  text-align: center;
  border: 1px solid gray;
  background-color: #546e7a;
  border-radius: 13px;
  width: 46px;
  padding: 3px;
  color: white;
  font-weight: 300 !important;
  font-size: 0.75rem !important;
  font-weight: 400;
  letter-spacing: 0.0333333333em !important;
  line-height: 1.25rem;
}
</style>

  